import { ComponentType } from 'data-types-config';
import type { RedirectPatternProps } from './RedirectPattern.types';

export const redirectPatternDefaults: Partial<RedirectPatternProps> = {
  componentType: ComponentType.Internal,
  isDisabled: false,
  isVisible: true,
  text: '',
};
